// 类似 yms 详情的模板样式逻辑 start
var $window = $(window);
var winHeight = $window.height();
var amzVideoImgs = $.map($('.lepro-amz-video-img-2024 .lepro-video, .lepro-amz-video-describe-2024 .lepro-video').get(), function (i) { return $(i); });
var amzVideoImgSliders = $.map($('.lepro-amz-video-img-slider-2024 .lepro-amz-carousel').get(), function (i) { return $(i); });
// 类似 yms 详情的模板样式逻辑 end

$(function(){
    // 类似 yms 详情的模板样式逻辑 start
    // loadCarouselAmzVideoImg()
    // initAmzVideoImg()
    initQaBlock()
    // 类似 yms 详情的模板样式逻辑 end

    var isShowBtn = false
    var isShowReviews = false
    var judgmentNum = 20
    var currentTimers = 0
    var setTimers =setInterval(function () {
        if ((isShowBtn && isShowReviews) || currentTimers > judgmentNum) {
            clearInterval(setTimers)
            return
        }
        setStyle()
        currentTimers += 1
    }, 2000)

    function setStyle () {
        if ($('.bwp-widget-loaded').length > 0 && !isShowBtn) {
            isShowBtn = true
            if ($('#bwpFrame.vwo_loaded').length < 1) {
                $('.custom-amzn-buy').show()
            }
        }
        
        if ($('#roaReviewsIframe').css('height') != '0px' && !isShowReviews) {
            isShowReviews = true
            $('#product_aw_reviews_tab').addClass('pro_desc_nav_content_hide')
            $('.amzn-rating-wrapper').addClass('amzn-rating-wrapper-initheight')
            // if ($('div[data-role="aw-ar-product-summary-container"]')) {
            //     $('div[data-role="aw-ar-product-summary-container"]').hide()
            // }
        }

        if (currentTimers > judgmentNum - 2 && !isShowReviews) {
            isShowReviews = true
            $('#roaReviewsIframe').hide()
            $('#roaRatingIframe').hide()
        }
    }

    $(window).scroll(function(){
        // if($(document).scrollTop() > (parseFloat($('#product-addtocart-button').offset().top)+parseFloat($('#product-addtocart-button').height()))){
        //     if(!$('.add-to-cart-wrapper').hasClass('animate') && !$('.add-to-cart-wrapper-expand').hasClass('animate')){
        //         if($('.add-to-cart-wrapper-expand').attr('is-expand') != 1){
        //             $('.add-to-cart-wrapper').addClass('animate');
        //             $('.add-to-cart-wrapper-expand').removeClass('animate');
        //         }else{
        //             $('.add-to-cart-wrapper').removeClass('animate');
        //             $('.add-to-cart-wrapper-expand').addClass('animate');
        //         }
        //     }
        // }else{
        //     $('.add-to-cart-wrapper').removeClass('animate');
        //     $('.add-to-cart-wrapper-expand').removeClass('animate');
        // }

        loadCarouselAmzVideoImg()
        initAmzVideoImg()
    });

    $('body').on("click",'.select_num_btn_small',function(){

        var $this = $(this);
        var currentQty = $("#float_qty").val();
        if($this.hasClass('add')){
            var newAdd = parseInt(currentQty)+parseInt(1);
            $("#float_qty").val(newAdd);
        }
        if($this.hasClass('subtract') && currentQty>1){
            var newAdd = parseInt(currentQty)-parseInt(1);
            $("#float_qty").val(newAdd);
        }
    });

    $('body').on("blur",'#float_qty',function(){
        var $this = $(this);
        var value = $(this).val();
        if (value=="") {
            $(this).val(1);
        }
        //如果文本值为非纯数字,设置为1
        //isNaN()是否为非法数字
        if (isNaN(value)) {
            $(this).val(1);
        }
        //如果文本值小于1,设置为1
        if (parseInt(value)<=1) {
            $(this).val(1);
        }
        var value = $this.val();
    });

    $('body').on("click",'.add-to-cart-wrapper .collapse',function(){
        $('.add-to-cart-wrapper').removeClass('animate');
        $('.add-to-cart-wrapper-expand').attr('is-expand','1').addClass('animate');
    });

    $('body').on("click",'.add-to-cart-wrapper-expand',function(){
        $('.add-to-cart-wrapper').addClass('animate');
        $('.add-to-cart-wrapper-expand').attr('is-expand','0').removeClass('animate');
    });
    
    $('.lepro-slick-wrap').slick({
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 3,
        speed: 120,
        dots: true
    });

    // 详情内容中的轮播图
    var sliderDom = $('.buy-form-slick-slider')
    if (sliderDom.length > 0) {
        $('.buy-form-slick-slider').slick({
            dots: true,
            lazyLoad: 'ondemand',
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            // autoplay: true,
            autoplaySpeed: 5000,
            prevArrow: '<button type="button" class="buy-form-slick-prev"><i class="fa fa-angle-left fa-lg"></i></button>',
            nextArrow: '<button type="button" class="buy-form-slick-next"><i class="fa fa-angle-right fa-lg"></i></button>',
            afterChange: function (event, slick, currentSlide) {}
        });
    }

    loadImgFun()
    initCarousel()
});

// 加载图片
function loadImgFun() {
    var setTime = setTimeout(function() {
        var lazyImgs = $.map($('img[data-src]').get(), function (i) {
            return $(i);
        });
        if (lazyImgs.length > 0) {
            var loadedIndex = [];
            lazyImgs.forEach(function ($i, index) {
                $i.attr('src', $i.attr('data-src'));
                loadedIndex.unshift(index);
            });
            loadedIndex.forEach(function (index) {
                lazyImgs.splice(index, 1);
            });
        };
        setTime = null;
        clearTimeout(setTime);
    }, 10);
}

function initCarousel() {
    /**
     * 一共三个轮播图
     * carouselOneDom：自定义了切换按钮
     * carouselTwoDom：使用默认切换按钮
     * carouselThreeDom：自定义了切换按钮 --- 样式不一样
     * carouselFourDom：另一种样式轮播
     */
    var carouselOneDom = $('.lepro-details-con-main2303 .lepro-section-carousel-one')
    var carouselTwoDom = $('.lepro-details-con-main2303 .lepro-section-carousel-two')
    var carouselThreeDom = $('.lepro-details-con-main2303 .lepro-section-carousel-three')
    var carouselFourDom = $('.lepro-details-con-main2303 .lepro-section-carousel-four')
    if (carouselOneDom.length) {
        for (var keyIndex = 0; keyIndex < carouselOneDom.length; keyIndex++) {
            initCarouselOne(keyIndex, carouselOneDom)
        }
    }
    if (carouselTwoDom.length) {
        for (var keyIndex = 0; keyIndex < carouselTwoDom.length; keyIndex++) {
            initCarouselTwo(keyIndex, carouselTwoDom)
        }
    }
    if (carouselThreeDom.length) {
        for (var keyIndex = 0; keyIndex < carouselThreeDom.length; keyIndex++) {
            initCarouselThree(keyIndex, carouselThreeDom)
        }
    }
    if (carouselFourDom.length) {
        for (var keyIndex = 0; keyIndex < carouselFourDom.length; keyIndex++) {
            initCarouselFour(keyIndex, carouselFourDom)
        }
    }
}
//  carouselOneDom：自定义了切换按钮
function initCarouselOne(keyIndex, carouselOneDom) {
    var main2303CarouselDom = $(carouselOneDom[keyIndex]).find('.lepro-main2303-carousel')
    var main2303DotsDom = $(carouselOneDom[keyIndex]).find('.dots-list h4')
    main2303CarouselDom.on('init', function(event, slick){
        // 初始化
        main2303DotsDom.eq(0).addClass('active')
    });
    main2303CarouselDom.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        // 切换轮播图
        main2303DotsDom.eq(nextSlide).addClass('active').siblings().removeClass('active');
    });
    main2303DotsDom.on('click', function() {
        // 点击切换按钮
        main2303CarouselDom.slick('slickGoTo', $(this).index());
        $(this).addClass('active').siblings().removeClass('active');
    })
    main2303CarouselDom.slick({
        prevArrow: '<a href="#" class="main2303-slick-prev"><i></i></a>',
        nextArrow: '<a href="#" class="main2303-slick-next"><i></i></a>',
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        speed: 320,
        draggable: false,
        useTransform: false,
        // autoplay: true,
        dots: false
    });
    $(carouselOneDom[keyIndex]).show()
}

// carouselTwoDom：使用默认切换按钮
function initCarouselTwo(keyIndex, carouselTwoDom) {
    var main2303CarouselDomTwo = $(carouselTwoDom[keyIndex]).find('.lepro-main2303-carousel')
    main2303CarouselDomTwo.slick({
        prevArrow: '<a href="#" class="main2303-slick-prev"><i></i></a>',
        nextArrow: '<a href="#" class="main2303-slick-next"><i></i></a>',
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        speed: 320,
        draggable: false,
        useTransform: false,
        // autoplay: true,
        dots: true
    });
    $(carouselTwoDom[keyIndex]).show()
}

// carouselThreeDom：自定义了切换按钮 --- 样式不一样
function initCarouselThree(keyIndex, carouselThreeDom) {
    var main2303CarouselDomThree = $(carouselThreeDom[keyIndex]).find('.lepro-main2303-carousel')
    var main2303DotsDomThree = $(carouselThreeDom[keyIndex]).find('.dots-list h4')
    main2303CarouselDomThree.on('init', function(event, slick){
        main2303DotsDomThree.eq(0).addClass('active')
    });
    main2303CarouselDomThree.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        main2303DotsDomThree.eq(nextSlide).addClass('active').siblings().removeClass('active');
    });

    main2303DotsDomThree.on('click', function() {
        main2303CarouselDomThree.slick('slickGoTo', $(this).index());
        $(this).addClass('active').siblings().removeClass('active');
    })

    main2303CarouselDomThree.slick({
        prevArrow: '<a href="#" class="main2303-slick-prev"><i></i></a>',
        nextArrow: '<a href="#" class="main2303-slick-next"><i></i></a>',
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 1,
        speed: 320,
        draggable: false,
        useTransform: false,
        dots: false
    });
    $(carouselThreeDom[keyIndex]).show()
}

// carouselFourDom：自定义了切换按钮和菜单切换
function initCarouselFour(keyIndex, carouselFourDom) {
    var main2303CarouselDomFour = $(carouselFourDom[keyIndex]).find('.lepro-main2303-carousel')
    var main2303DotsDomFour = $(carouselFourDom[keyIndex]).find('.dots-list-four h4')
    main2303CarouselDomFour.on('init', function(event, slick){
        main2303DotsDomFour.eq(0).addClass('active')
    });
    main2303CarouselDomFour.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        main2303DotsDomFour.eq(nextSlide).addClass('active').siblings().removeClass('active');

        if ($(carouselFourDom[keyIndex]).find('.dots-list-four') && $(carouselFourDom[keyIndex]).find('.dots-list-four').length > 0) {
            var parScrollLeft = $(carouselFourDom[keyIndex]).find('.dots-list-four').scrollLeft()
            var parDomActiveWidth = main2303CarouselDomFour.innerWidth()
            var parDomActiveOffset = main2303CarouselDomFour.offset().left
            var domActive = main2303DotsDomFour.eq(nextSlide)
            var domActiveWidth = domActive.innerWidth()
            var domActiveOffset = domActive.offset().left - parDomActiveOffset
    
            var scrollLeft = domActiveOffset + domActiveWidth - parDomActiveWidth + parScrollLeft + 8
            var exceedGap = domActiveOffset + domActiveWidth
    
            if (exceedGap > parDomActiveWidth || domActiveOffset < 0) {
                if (scrollLeft > 0) {
                    $(carouselFourDom[keyIndex]).find('.dots-list-four').animate({ scrollLeft: scrollLeft }, 200);
                } else {
                    $(carouselFourDom[keyIndex]).find('.dots-list-four').animate({ scrollLeft: 0 }, 200);
                }
            }
        }
    });

    main2303DotsDomFour.on('click', function() {
        main2303CarouselDomFour.slick('slickGoTo', $(this).index());
        $(this).addClass('active').siblings().removeClass('active');
    })
    main2303CarouselDomFour.slick({
        prevArrow: '<a href="#" class="main2303-slick-prev"><i></i></a>',
        nextArrow: '<a href="#" class="main2303-slick-next"><i></i></a>',
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 1,
        speed: 320,
        draggable: false,
        useTransform: false,
        dots: false
    });
    $(carouselFourDom[keyIndex]).show()
}

// 类似 yms 详情的模板样式逻辑 start ******
// QA 折叠面板
function initQaBlock () {
    var qaBlockDom = $('.lepro-qa-section-2024 .lepro-qa-block') // QA 折叠面板

    qaBlockDom.on('click', function () {
        var leproExpanded = $(this).attr('lepro-expanded')
        if (leproExpanded == 'false') {
            $(this).attr('lepro-expanded', 'true')
            $(this).addClass('lepro-qa-block-active')
        } else {
            $(this).attr('lepro-expanded', 'false')
            $(this).removeClass('lepro-qa-block-active')
        }
    })
}
// 文本视频
function initAmzVideoImg () {
    if (amzVideoImgs.length > 0) {
        var wtop = $window.scrollTop();
        var loadedIndex = [];
        amzVideoImgs.forEach(function ($i, index) {
            var differenceNum = $i.offset().top - wtop;
            if (differenceNum < winHeight) {
                var asyncSrc = $i.find('source').attr('async-src')
                if (asyncSrc) {
                    $i.find('source').attr('src', asyncSrc)
                    $i.find('source').removeAttr('async-src')
                    var videoPlay = videojs($i[0])
                    videoPlay.on('pause', function() {
                        $(this.el_).find('.vjs-big-play-button').show(0)
                    })
                    videoPlay.on('play', function() {
                        $(this.el_).find('.vjs-big-play-button').hide(0)
                    })
                }
                loadedIndex.unshift(index);
            }
        });
        loadedIndex.forEach(function (index) {
            amzVideoImgs.splice(index, 1);
        });
    };
}
// 文本视频轮播
function loadCarouselAmzVideoImg () {
    if (amzVideoImgSliders.length > 0) {
        var wtop = $window.scrollTop();
        var loadedIndex = [];

        amzVideoImgSliders.forEach(function ($i, index) {
            var differenceNum = $i.offset().top - wtop;
            if (differenceNum < winHeight) {
                var videoSources = $i.find('.lepro-video')
                for (var $j = 0; $j < videoSources.length; $j++) {
                    var videosDom = $(videoSources[$j])
                    var asyncSrc = $(videoSources[$j]).find('source').attr('async-src')
                    $(videoSources[$j]).find('source').attr('src', asyncSrc)
                    $(videoSources[$j]).find('source').removeAttr('async-src')

                    var videoPlay = videojs(videosDom[0])
                    videoPlay.on('pause', function() {
                        $(this.el_).find('.vjs-big-play-button').show(0)
                    })
                    videoPlay.on('play', function() {
                        $(this.el_).find('.vjs-big-play-button').hide(0)
                    })
                }
                loadedIndex.unshift(index);
                
                $i.addClass('le-opacity-show')
                initcarouselAmzVideoImg($i)
            }
        });
        loadedIndex.forEach(function (index) {
            amzVideoImgSliders.splice(index, 1);
        });
    }
}
//  carouselAmzVideoImgDom：自定义了切换按钮
function initcarouselAmzVideoImg(carouselDom) {
    carouselDom.on('init', function(event, slick){
        // 初始化
        if ($(window).width() < 751) {
            var timerC = setTimeout(function () {
                if (slick.$list.find && slick.$list.find('.lepro-video-wrap').length > 0) {
                    var listVideoHeight = slick.$list.find('.lepro-video-wrap')[0].offsetHeight
                    slick.$dots.css({ top: listVideoHeight + 8 })
                    clearTimeout(timerC)
                    timerC = null
                }
            }, 100)
        }

    });
    carouselDom.slick({
        prevArrow: '<a href="#" class="custom-slick-prev"><i></i></a>',
        nextArrow: '<a href="#" class="custom-slick-next"><i></i></a>',
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        speed: 320,
        draggable: false,
        useTransform: false,
        dots: true
    })
}
// 类似 yms 详情的模板样式逻辑 end ******
